if (!window.Eurus.loadedScript.has('featured-collection.js')) {
  window.Eurus.loadedScript.add('featured-collection.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xFeaturedCollection', (sectionId, pageParam, container) => ({
        sectionId: sectionId,
        pageParam: pageParam,
        currentTab: 1,
        loading: true,
        loaded: [],
        init() {
          this.shuffleProducts(container);
        },
        shuffleProducts(rootEl) {
          if (!rootEl) return;
          const lists = rootEl.querySelectorAll('[data-randomize-products]');
          lists.forEach(list => {
            const displayCount = parseInt(list.dataset.displayCount, 10);
            // Only shuffle product cards — exclude inline <style>/<script> tags
            // emitted by the Liquid loop, which are direct children of this list.
            const items = Array.from(list.children).filter(el => {
              const tag = el.tagName;
              return tag !== 'STYLE' && tag !== 'SCRIPT';
            });
            if (items.length === 0) return;
            for (let i = items.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [items[i], items[j]] = [items[j], items[i]];
            }
            items.forEach((item, idx) => {
              if (displayCount > 0 && idx >= displayCount) {
                item.remove();
              } else {
                list.appendChild(item);
              }
            });
          });
        },
        select(index) {
          this.currentTab = index;
        },
        loadData(index) {
          const selectedPage = index - 1;
          if (!this.loaded.includes(selectedPage)) {
            this.loading = true;

            let url = `${window.location.pathname}?section_id=${this.sectionId}&${this.pageParam}=${index}`;
            fetch(url, {
              method: 'GET'
            }).then(
              response => response.text()
            ).then(responseText => {
              const html = (new DOMParser()).parseFromString(responseText, 'text/html');
              const contentId = `x-fc-${this.sectionId}-${index}`;
              const newContent = html.getElementById(contentId);
              if (newContent && !document.getElementById(contentId)) {
                this.shuffleProducts(newContent);
                container.appendChild(newContent);
                this.loaded.push(selectedPage);
              }
              this.loading = false;
            })
          }
        },
        scrollIntoView(element) {
          const scrollableContainer = element.closest('.overflow-x-auto'); 
          const elementPosition = element.offsetLeft;

          scrollableContainer.scroll({
            left: elementPosition,
            behavior: 'smooth'
          });
        }
      }));
    });
  });
}